<template>
  <v-row
    no-gutters
    justify="center"
    align="start"
    class="planning px-12"
    @mousemove="mouseMoved"
    @mouseup="endDragOrResize"
  >
    <intervention-dialog
      v-model="isInterventionOpened"
      :id="openedInterventionId"
      @change="fetchInterventions"
      @close="openedInterventionId = null"
    />
    <change-assignee-dialog
      :intervention="changeAssigneeDialogIntervention"
      @close="changeAssigneeDialogIntervention = null"
      @updated="interventionAssigneeChanged"
      v-if="changeAssigneeDialogIntervention !== null"
    />
    <v-menu
      ref="menu"
      v-model="isInterventionContextMenuOpened"
      transition="scale-transition"
      offset-y
      absolute
      :position-x="interventionContextMenuX"
      :position-y="interventionContextMenuY"
      min-width="250"
    >
      <n-card>
        <v-list dense class="py-0">
          <v-list-item @click="openIntervention(contextMenuIntervention)">
            <v-list-item-icon>
              <v-icon>visibility</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              Ouvrir
            </v-list-item-content>
          </v-list-item>
          <v-divider />
          <v-list-item :disabled="!$canWrite" @click="$canWrite && (openChangeAssigneeDialog(contextMenuIntervention))">
            <v-list-item-icon>
              <v-icon>person_add</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              Assigner à
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </n-card>
    </v-menu>
    <div class="n-container">
      <v-row no-gutters justify="center" align="start">
        <v-col>
          <div>
            <v-row no-gutters align="center" class="content-header">
              <v-icon small color="accent" class="mr-2 font-weight-bold">event</v-icon>
              <span class="font-weight-bold primary--text">Planning</span>
              <v-spacer />
              <!-- <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="n-small-btn n-white-btn ml-2"
                  >
                    {{ currentViewTimeMode.label }}
                    <v-icon right small class="ml-2">expand_more</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(viewTimeMode, index) in viewTimeModes"
                    :key="index"
                    @click="setViewTimeMode(viewTimeMode)"
                  >
                    <v-list-item-title>{{ viewTimeMode.label }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu> -->
              <!-- <pager class="ml-3" @previous="previousPage" @next="nextPage" />
              <v-btn class="n-white-btn n-small-btn n-icon-btn ml-3" @click="fetchInterventions">
                <v-icon small class="accent--text font-weight-bold">refresh</v-icon>
              </v-btn> -->
              <v-expand-x-transition v-if="false">
                <div v-show="!isRightPanOpened">
                  <v-btn class="n-small-btn n-primary-btn ml-3" @click="isRightPanOpened = true">
                    <v-icon left small class="mr-2 font-weight-bold">inbox</v-icon>
                    À plannifer
                  </v-btn>
                </div>
              </v-expand-x-transition>
            </v-row>
            <v-row no-gutters align="center" class="content-header mb-4" style="height: 35px;">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="n-small-btn n-white-btn"
                  >
                    {{ currentViewRowsMode.label }}
                    <v-icon right small class="ml-2">expand_more</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(viewRowsMode, index) in viewRowsModes"
                    :key="index"
                    @click="setViewRowsMode(viewRowsMode)"
                  >
                    <v-list-item-title>{{ viewRowsMode.label }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-col class="px-4">
                <v-text-field
                  v-model="searchString"
                  outlined
                  dense
                  height="32px"
                  hide-details
                  placeholder="Rechercher..."
                  prepend-inner-icon="search"
                  class="search-input"
                />
              </v-col>
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="n-small-btn n-white-btn ml-2"
                  >
                    {{ currentViewTimeMode.label }}
                    <v-icon right small class="ml-2">expand_more</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(viewTimeMode, index) in viewTimeModes"
                    :key="index"
                    @click="setViewTimeMode(viewTimeMode)"
                  >
                    <v-list-item-title>{{ viewTimeMode.label }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <pager class="ml-3" @previous="previousPage" @next="nextPage" />
              <v-btn class="n-white-btn n-small-btn n-icon-btn ml-3" @click="fetchInterventions">
                <v-icon small class="accent--text font-weight-bold">refresh</v-icon>
              </v-btn>
            </v-row>
            <div class="page-main-content">
              <n-card>
                <v-row no-gutters justify="center" align="stretch">
                  <div class="planning-col-1" style="background: #FFF; border-right: 1px solid #CCC;">
                    <v-row no-gutters justify="center" align="center" class="planning-col-header" style="border-bottom: 2px solid #CCC;">
                      {{ currentViewRowsMode.headerLabel }}
                    </v-row>
                    <div class="planning-col-content">
                      <div
                        v-for="(rowsItem, i) in rowsItems"
                        :key="i"
                        class="planning-user-line px-2"
                        :style="{
                          height: rowsItem.style.height,
                        }"
                      >
                        <v-row no-gutters justify="center" align="center" class="fill-height text-truncate">
                          <div class="text-truncate font-weight-medium">
                            {{ rowsItem.$rowLabel }}
                          </div>
                        </v-row>
                      </div>
                    </div>
                  </div>
                  <v-col class="planning-col-2" ref="daysContent">
                    <v-row no-gutters justify="center" align="stretch" class="planning-col-grid">
                      <v-col
                        v-for="(day, i) in days"
                        :key="i"
                        class="grid-day"
                        :class="{
                          'weekend-day': day.$isWeekend,
                          'first-day-week': day.$weekDay === 1,
                        }"
                      >
                        &nbsp;
                      </v-col>
                    </v-row>
                    <div class="planning-col-header">
                      <div class="planning-col-header-line">
                        <v-row no-gutters justify="center" align="center" class="fill-height months-header">
                          <v-row no-gutters justify="start" align="center" class="month-header fill-height">
                            <div class="text-truncate">
                              {{ periodLabel }}
                            </div>
                          </v-row>
                        </v-row>
                      </div>
                      <div class="planning-col-header-line">
                        <v-row no-gutters justify="center" align="center" class="fill-height days-header" style="border-bottom: 2px solid #CCC;">
                          <v-col
                            v-for="(day, i) in days"
                            :key="i"
                            class="day-header"
                          >
                            {{ day.$header }}
                            <div
                              class="week-number"
                              v-if="viewTimeMode !== `week` && (i === 0 || days[i - 1].$week !== day.$week)"
                            >
                              S{{ day.$week }}
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </div>
                    <v-row
                      no-gutters
                      justify="center"
                      align="center"
                      class="planning-col-content planning-col-content-overlay"
                      v-if="isFetchningInterventions"
                    >
                      <v-progress-circular indeterminate color="primary darken-1" />
                    </v-row>
                    <div class="planning-col-content" v-else>
                      <template v-for="(rowsItem, i) in rowsItems">
                        <div
                          :key="i"
                          class="planning-user-line"
                          style="position: relative; overflow: hidden;"
                          :style="{
                            height: rowsItem.style.height,
                          }"
                        >
                          <template v-for="intervention in rowsItem.interventions">
                            <v-tooltip
                              :key="`intervention-${intervention.id}`"
                              :disabled="
                                   isDraggingIntervention
                                || isResizingIntervention
                                || isInterventionContextMenuOpened
                              "
                              top
                              open-delay="200"
                              color="primary darken-1"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <div
                                  v-bind="attrs"
                                  v-on="on"
                                  class="user-intervention-wrapper"
                                  :class="{
                                    'left-truncated': intervention.style.isLeftTruncated,
                                    'right-truncated': intervention.style.isRightTruncated,
                                  }"
                                  :style="{
                                    top: intervention.style.top,
                                    left: intervention.style.left,
                                    width: intervention.style.width,
                                  }"
                                  @mousedown="startDragIntervention($event, intervention)"
                                  @click="openIntervention(intervention)"
                                  @contextmenu.prevent="e => openInterventionContextMenu(e, intervention)"
                                >
                                  <v-row
                                    no-gutters
                                    justify="start"
                                    align="center"
                                    class="user-intervention"
                                    :style="{
                                      backgroundColor: intervention.status.color,
                                      color: intervention.status.fontColor,
                                    }"
                                  >
                                    <div class="user-intervention-text-wrapper">
                                      <div class="user-intervention-text">
                                        {{ intervention.$label }}
                                      </div>
                                    </div>
                                    <template v-if="!intervention.isPlannedHourly">
                                      <div
                                        class="intervention-resize-left-handler"
                                        @mousedown="startResizeIntervention($event, intervention, `left`)"
                                        v-if="intervention.$startsInPeriod"
                                      >
                                      </div>
                                      <div
                                        class="intervention-resize-right-handler"
                                        @mousedown="startResizeIntervention($event, intervention, `right`)"
                                        v-if="intervention.$endsInPeriod"
                                      >
                                      </div>
                                    </template>
                                  </v-row>
                                </div>
                              </template>
                              <div>
                                <div><v-icon color="white" small left>business</v-icon> {{ intervention.client.name }}</div>
                                <div v-if="!intervention.client.isMonoSite"><v-icon color="white" small left>place</v-icon> {{ intervention.site.name }}</div>
                                <div><v-icon color="white" small left>person</v-icon>&nbsp;
                                  <template v-if="intervention.assignee">
                                    {{ intervention.assignee.firstname }} {{ intervention.assignee.lastname }}
                                  </template>
                                  <template v-else>
                                    <span class="font-italic">Non assigné</span>
                                  </template>
                                </div>
                                <div><v-icon color="white" small left>title</v-icon> {{ intervention.title }}</div>
                                <div><v-icon color="white" small left>event</v-icon> {{ intervention | formatInterventionDate }}</div>
                              </div>
                            </v-tooltip>
                          </template>
                        </div>
                      </template>
                    </div>
                  </v-col>
                </v-row>
              </n-card>
            </div>
          </div>
        </v-col>
        <v-expand-x-transition>
          <div v-show="isRightPanOpened">
            <div class="side-content-medium ml-6">
              <v-row no-gutters align="center" class="content-header">
                <v-icon small color="accent" class="mr-2 font-weight-bold">inbox</v-icon>
                <div class="font-weight-bold primary--text">À plannifier</div>
                <v-spacer></v-spacer>
                <v-btn icon color="primary" @click="isRightPanOpened = false">
                  <v-icon small>clear</v-icon>
                </v-btn>
              </v-row>
              <n-card>
                Coucou
              </n-card>
            </div>
          </div>
        </v-expand-x-transition>
      </v-row>
    </div>
  </v-row>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import Pager from '@/components/Planning/Pager.vue';
import InterventionDialog from '@/components/Interventions/InterventionDialog.vue';
import ChangeAssigneeDialog from '@/components/Interventions/ChangeAssignee.vue';
import {
  mapActions,
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';

export default {
  data: () => ({
    viewTimeModes: [
      { id: `week`, label: `Semaine` },
      { id: `month`, label: `Mois` },
    ],
    viewRowsModes: [
      { id: `users`, label: `Par technicien`, headerLabel: `Techniciens` },
      { id: `clients`, label: `Par client`, headerLabel: `Clients` },
      // { id: `sites`, label: `Par site`, headerLabel: `Sites` },
    ],
    isRightPanOpened: false,
    isFetching: false,
    isFetchningUsers: false,
    isFetchningInterventions: false,
    openedInterventionId: null,
    isDraggingIntervention: false,
    isResizingIntervention: false,
    dragInformations: null,
    resizeInformations: null,
    contextMenuIntervention: null,
    isInterventionContextMenuOpened: false,
    interventionContextMenuX: 0,
    interventionContextMenuY: 0,
    changeAssigneeDialogIntervention: null,
  }),
  computed: {
    ...mapState(`ui/planning`, [
      `firstChoosenDay`,
    ]),
    ...mapState(`ui/planning`, {
      storeSearchString: `searchString`,
      storeViewTimeMode: `viewTimeMode`,
      storeViewRowsMode: `viewRowsMode`,
    }),
    ...mapGetters(`ui/planning`, {
      users: `usersWithInterventions`,
    }),
    ...mapGetters(`ui/planning`, [
      `interventions`,
      `days`,
      `firstDay`,
      `lastDay`,
      `weekNumber`,
      `clientsWithInterventions`,
    ]),
    searchString: {
      get() { return this.storeSearchString; },
      set(value) { this.SET_SEARCH_STRING(value); },
    },
    filteredUsers() {
      return _.filter(this.users, user => !user.isExcludedFromPlanning);
    },
    filteredClients() {
      return this.clientsWithInterventions;
    },
    rowsItems() {
      if (this.viewRowsMode === `users`) {
        return this.filteredUsers;
      }

      return this.filteredClients;
    },
    isInterventionOpened: {
      get() { return this.openedInterventionId !== null; },
      set() { this.openedInterventionId = null; },
    },
    viewTimeMode: {
      get() { return this.storeViewTimeMode; },
      set(value) { this.SET_VIEW_TIME_MODE(value); },
    },
    viewRowsMode: {
      get() { return this.storeViewRowsMode; },
      set(value) { this.SET_VIEW_ROWS_MODE(value); },
    },
    currentViewTimeMode() {
      return _.find(this.viewTimeModes, { id: this.viewTimeMode }) || { label: `-` };
    },
    currentViewRowsMode() {
      return _.find(this.viewRowsModes, { id: this.viewRowsMode }) || { label: `-` };
    },
    periodLabel() {
      if (this.viewTimeMode === `month`) {
        return _.upperFirst(this.firstChoosenDay.format(`MMMM YYYY`));
      }

      return `Semaine ${this.weekNumber}`;
    },
  },
  methods: {
    ...mapMutations(`ui/planning`, [
      `SET_VIEW_TIME_MODE`,
      `SET_VIEW_ROWS_MODE`,
      `SET_FIRST_CHOOSEN_DAY`,
      `SET_SEARCH_STRING`,
      `SET_INTERVENTIONS`,
    ]),
    ...mapActions(`ui/planning`, {
      storeFetchUsers: `fetchUsers`,
      storeFetchInterventions: `fetchInterventions`,
    }),
    ...mapActions(`model/intervention`, {
      updateInterventionPlannedDate: `updatePlannedDate`,
      addInterventionStep: `addStep`,
    }),
    autoSetFistChoosenDay() {
      if (this.viewTimeMode === `month`) {
        this.SET_FIRST_CHOOSEN_DAY(moment().startOf(`month`).startOf(`day`));
      } else {
        this.SET_FIRST_CHOOSEN_DAY(moment().startOf(`week`).startOf(`day`));
      }
    },
    async fetchUsers() {
      this.isFetchningUsers = true;
      await this.storeFetchUsers();
      this.isFetchningUsers = false;
    },
    async fetchInterventions() {
      this.isFetchningInterventions = true;
      await this.storeFetchInterventions();
      this.isFetchningInterventions = false;
    },
    async fetchAll() {
      this.isFetching = true;
      await Promise.all([
        this.fetchUsers(),
        this.fetchInterventions(),
      ]);
      this.isFetching = false;
    },
    setViewTimeMode(viewTimeMode) {
      this.viewTimeMode = viewTimeMode.id;
    },
    setViewRowsMode(viewRowsMode) {
      this.viewRowsMode = viewRowsMode.id;
    },
    previousPage() {
      this.SET_INTERVENTIONS([]);
      if (this.viewTimeMode === `week`) { this.previousWeek(); }
      if (this.viewTimeMode === `month`) { this.previousMonth(); }
      this.fetchInterventions();
    },
    nextPage() {
      this.SET_INTERVENTIONS([]);
      if (this.viewTimeMode === `week`) { this.nextWeek(); }
      if (this.viewTimeMode === `month`) { this.nextMonth(); }
      this.fetchInterventions();
    },
    previousWeek() {
      this.SET_FIRST_CHOOSEN_DAY(this.firstChoosenDay.clone().subtract(1, `week`));
    },
    nextWeek() {
      this.SET_FIRST_CHOOSEN_DAY(this.firstChoosenDay.clone().add(1, `week`));
    },
    previousMonth() {
      this.SET_FIRST_CHOOSEN_DAY(this.firstChoosenDay.clone().subtract(1, `month`));
    },
    nextMonth() {
      this.SET_FIRST_CHOOSEN_DAY(this.firstChoosenDay.clone().add(1, `month`));
    },
    openIntervention(intervention) {
      if (!this.isDraggingIntervention && !this.isResizingIntervention) {
        this.openedInterventionId = intervention.id;
        this.dragInformations = null;
      }
    },
    addDaysToDate(date, nbDays) {
      const updatedDate = date.clone();
      const nbDaysAbs = Math.abs(nbDays);
      const method = nbDays > 0 ? `add` : `subtract`;
      for (let index = 0; index < nbDaysAbs; index += 1) {
        updatedDate[method](1, `days`);
      }

      return updatedDate;
    },
    openChangeAssigneeDialog(intervention) {
      this.changeAssigneeDialogIntervention = intervention;
    },
    interventionAssigneeChanged(intervention) {
      this.changeAssigneeDialogIntervention = null;
      const localIntervention = _.find(this.interventions, { id: intervention.id });
      const newInterventionData = {
        ...localIntervention,
        Assignee_id: intervention.Assignee_id,
        assignee: intervention.assignee,
      };
      this.$store.dispatch(`ui/planning/updateInterventionLocally`, newInterventionData);
    },
    openInterventionContextMenu(event, intervention) {
      this.contextMenuIntervention = intervention;
      this.interventionContextMenuX = event.clientX;
      this.interventionContextMenuY = event.clientY;
      this.isInterventionContextMenuOpened = true;
    },
    startDragIntervention(evt, intervention) {
      if (!this.$canWrite) { this.dragInformations = null; this.resizeInformations = null; return; }
      evt.preventDefault();
      if (evt.which === 1 && evt.ctrlKey !== true) {
        const dayWidth = this.$refs.daysContent.offsetWidth / (this.days.length);
        if (!intervention.isPlannedHourly) {
          this.dragInformations = {
            dayWidth,
            intervention,
            startEvent: evt,
            diffX: 0,
            hasDragged: false,
          };
        }
      }
    },
    startResizeIntervention(evt, intervention, direction) {
      if (!this.$canWrite) { this.dragInformations = null; this.resizeInformations = null; return; }
      evt.preventDefault();
      evt.stopPropagation();
      const dayWidth = this.$refs.daysContent.offsetWidth / (this.days.length);
      this.resizeInformations = {
        dayWidth,
        intervention,
        direction,
        startEvent: evt,
        diffX: 0,
        hasDragged: false,
      };
    },
    mouseMoved(evt) {
      if (this.dragInformations !== null) {
        const diffX = evt.clientX - this.dragInformations.startEvent.clientX;
        this.isDraggingIntervention = this.isDraggingIntervention || Math.abs(diffX) > 10;
        if (this.isDraggingIntervention && diffX !== this.dragInformations.diffX) {
          this.dragInformations = {
            ...this.dragInformations,
            diffX,
            hasDragged: this.dragInformations.hasDragged || Math.abs(diffX) > this.dragInformations.dayWidth / 4,
          };
        }
      } else if (this.resizeInformations !== null) {
        const diffX = evt.clientX - this.resizeInformations.startEvent.clientX;
        this.isResizingIntervention = Math.abs(diffX) > this.resizeInformations.dayWidth / 6;
        this.resizeInformations = {
          ...this.resizeInformations,
          diffX,
        };
      }
    },
    endDragIntervention() {
      const intervention = _.find(this.interventions, { id: this.dragInformations.intervention.id });

      this.updateInterventionPlannedDate({
        interventionId: intervention.id,
        plannedStartAt: intervention.plannedStartAt,
        plannedEndAt: intervention.plannedEndAt,
        isPlannedHourly: false,
        plannedDaysDuration: intervention.plannedDaysDuration,
      });

      const formattedDate = this.$options.filters.formatInterventionDate({
        plannedStartAt: intervention.plannedStartAt,
        plannedEndAt: intervention.plannedEndAt,
        lower: true,
      });
      const comment = `Intervention planifiée ${formattedDate}`;
      this.addInterventionStep({
        interventionId: intervention.id,
        statusId: intervention.Status_id,
        comment,
      });

      setTimeout(() => {
        this.isDraggingIntervention = false;
        this.dragInformations = null;
      }, 100);
    },
    endResizeIntervention() {
      const intervention = _.find(this.interventions, { id: this.resizeInformations.intervention.id });

      this.updateInterventionPlannedDate({
        interventionId: intervention.id,
        plannedStartAt: intervention.plannedStartAt,
        plannedEndAt: intervention.plannedEndAt,
        isPlannedHourly: false,
        plannedDaysDuration: intervention.plannedDaysDuration,
      });

      const formattedDate = this.$options.filters.formatInterventionDate({
        plannedStartAt: intervention.plannedStartAt,
        plannedEndAt: intervention.plannedEndAt,
        lower: true,
      });
      const comment = `Intervention planifiée ${formattedDate}`;
      this.addInterventionStep({
        interventionId: intervention.id,
        statusId: intervention.Status_id,
        comment,
      });

      setTimeout(() => {
        this.isResizingIntervention = false;
        this.resizeInformations = null;
      }, 100);
    },
    endDragOrResize() {
      if (!this.$canWrite) { this.dragInformations = null; this.resizeInformations = null; return null; } // eslint-disable-line
      const isDragging = this.dragInformations && this.isDraggingIntervention;
      const isResizing = Boolean(this.resizeInformations);
      // if (!isDragging && !isResizing) { return; }

      if (isDragging) { return this.endDragIntervention(); }
      if (isResizing) { return this.endResizeIntervention(); }
      return null;
    },
  },
  watch: {
    viewTimeMode() {
      this.autoSetFistChoosenDay();
      this.fetchInterventions();
    },
    dragInformations(dragInformations) {
      if (dragInformations !== null) {
        const { intervention } = dragInformations;
        const nbDaysDiff = Math.round(dragInformations.diffX / dragInformations.dayWidth);

        let newStartAt = this.addDaysToDate(moment(dragInformations.intervention.plannedStartAt, `YYYYMMDD`), nbDaysDiff);
        let newEndAt = this.addDaysToDate(newStartAt, intervention.plannedDaysDuration - 1);

        const firstMonday = moment(this.firstMonday, `YYYYMMDD`);
        const lastFriday = moment(this.lastFriday, `YYYYMMDD`);

        if (newEndAt.isBefore(firstMonday)) {
          newEndAt = firstMonday;
          newStartAt = this.addDaysToDate(newEndAt, -(intervention.plannedDaysDuration - 1));
        } else if (newStartAt.isAfter(lastFriday)) {
          newStartAt = lastFriday;
          newEndAt = this.addDaysToDate(newStartAt, intervention.plannedDaysDuration - 1);
        }

        const plannedDaysDuration = moment(newEndAt, `YYYYMMDDHHmm`)
          .diff(moment(newStartAt, `YYYYMMDDHHmm`), `days`) + 1;

        const newInterventionData = {
          ...intervention,
          plannedStartAt: newStartAt.format(`YYYYMMDD0000`),
          plannedEndAt: newEndAt.format(`YYYYMMDD0000`),
          plannedDaysDuration,
        };

        this.$store.dispatch(`ui/planning/updateInterventionLocally`, newInterventionData);
      }
    },
    resizeInformations(resizeInformations) {
      if (resizeInformations === null) { return; }

      const { intervention } = resizeInformations;

      const nbDaysDiff = Math.round(resizeInformations.diffX / resizeInformations.dayWidth);

      let newInterventionData = intervention;
      const startAt = moment(intervention.plannedStartAt, `YYYYMMDDHHmm`);
      const endAt = moment(intervention.plannedEndAt, `YYYYMMDDHHmm`);

      if (resizeInformations.direction === `left`) {
        const newStartAt = this.addDaysToDate(moment(intervention.plannedStartAt, `YYYYMMDD`), nbDaysDiff);

        if (newStartAt.isSameOrBefore(endAt) && newStartAt.isSameOrAfter(this.firstDay.moment)) {
          const plannedDaysDuration = moment(endAt, `YYYYMMDDHHmm`)
            .diff(moment(newStartAt, `YYYYMMDDHHmm`), `days`) + 1;

          newInterventionData = {
            ...intervention,
            plannedStartAt: newStartAt.format(`YYYYMMDD0000`),
            plannedEndAt: endAt.format(`YYYYMMDD0000`),
            plannedDaysDuration,
          };
        }
      } else if (resizeInformations.direction === `right`) {
        const newEndAt = this.addDaysToDate(moment(intervention.plannedEndAt, `YYYYMMDD`), nbDaysDiff);

        if (newEndAt.isSameOrAfter(startAt) && newEndAt.isSameOrBefore(this.lastDay.moment)) {
          const plannedDaysDuration = newEndAt.diff(startAt, `days`) + 1;

          newInterventionData = {
            ...intervention,
            plannedStartAt: startAt.format(`YYYYMMDD0000`),
            plannedEndAt: newEndAt.format(`YYYYMMDD0000`),
            plannedDaysDuration,
          };
        }
      }

      this.$store.dispatch(`ui/planning/updateInterventionLocally`, newInterventionData);
    },
  },
  beforeMount() {
    this.isDraggingIntervention = false;
    this.autoSetFistChoosenDay();
    this.fetchAll();
  },
  components: {
    Pager,
    InterventionDialog,
    ChangeAssigneeDialog,
  },
};
</script>

<style lang="scss">
$planningHeaderLineHeight: 35px;
$planningHeaderFullHeight: $planningHeaderLineHeight * 2;

.planning-col-1 {
  width: 200px;
}

.planning-col-1,
.planning-col-2 {
  position: relative;
}

.planning-col-header {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  height: $planningHeaderFullHeight;
  color: #333;
  font-weight: 500;

  .planning-col-header-line {
    height: $planningHeaderLineHeight;

    .day-header {
      position: relative;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      height: 100%;

      .week-number {
        position: absolute;
        top: 0px;
        left: 4px;
        transform: translate(0px, -55%);
        font-size: 9px;
        border: 1px solid #2d34b8;
        border-radius: 10px;
        background-color: #e0e5ff;
        padding: 1px 5px;
        font-weight: 600;
      }
    }
  }
}

.planning-col-content {
  position: relative;
  margin-top: $planningHeaderFullHeight;
}
.planning-col-content-overlay {
  position: absolute;
  margin: 0;
  top: $planningHeaderFullHeight;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, .5);
}

.planning-col-grid {
  position: absolute;
  top: $planningHeaderLineHeight;
  right: 0;
  bottom: 0;
  left: 0;
  // background-color: pink;

  .grid-day {
    background-color: #FFF;
    position: realtive;
    &:not(:first-child) {
      border-left: 1px solid #CCC;
      &.first-day-week {
        border-left: 1px solid #999;
      }
    }
    &.weekend-day {
      background-color: #ECEDF2;
    }
  }
}

.planning-user-line {
  height: 45px;
  &:not(:last-of-type) {
    border-bottom: 1px solid #CCC;
  }
}

.user-intervention-wrapper {
  position: absolute;
  top: 50%;
  margin-top: -10px;
  height: 25px;

  .user-intervention {
    position: absolute;
    cursor: pointer;
    height: 100%;
    left: 4px;
    right: 4px;
    // background-color: red;
    // background-color: #1d80e4;
    border-radius: 20px;
    padding: 0px 9px;
    font-size: 0.9rem;
    font-weight: 500;
    .user-intervention-text-wrapper {
      margin-top: 1px;
      display: table;
      table-layout: fixed;
      width: 100%;
      .user-intervention-text {
        display: table-cell;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }

    .intervention-resize-left-handler,
    .intervention-resize-right-handler {
      position: absolute;
      top: 0;
      bottom: 0;
      width: 6px;
      cursor: ew-resize;
      background-color: transparent;

      &:hover:after {
        content: "";
        position: absolute;
        top: 0;
        bottom: 0;
        width: 4px;
        background-color: #131a9a;
      }
    }
    .intervention-resize-left-handler {
      left: 0;
      &:hover:after {
        left: 0;
      }
    }
    .intervention-resize-right-handler {
      right: 0;
      &:hover:after {
        right: 0;
      }
    }
  }

  &.left-truncated {
    .user-intervention {
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
  }
  &.right-truncated {
    .user-intervention {
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;
    }
  }
}

.months-header {
  position: relative;
  // border-top: 1px solid #777;
  // border-left: 1px solid #777;
  // border-right: 1px solid #777;
  // border-top-left-radius: 8px;
  // border-top-right-radius: 8px;
  .month-header {
    // position: absolute;
    padding: 0px 6px;
    font-size: 0.9rem;
    font-weight: 500;
    // height: 25px;
    border-bottom: 1px solid #E8E8E8;
    &:not(:first-of-type) {
      margin-left: -1px;
      margin-right: 1px;
      border-left: 1px solid #E8E8E8;
    }
  }
}

.planning-user-label {
  font-size: 0.9rem;
  font-weight: 500;
  color: #444;
}

.days-header {
  position: relative;
  .day-header {
    font-weight: 500;
    font-size: 0.7rem;
    text-align: center;
    // &:not(:first-of-type) {
    //   border-left: 1px solid #777;
    // }
  }
}

.filter-item-title {
  font-weight: 500;
}

.filter-item-content-list {
  padding-top: 6px;
  & > a {
    padding: 6px 4px;
    display: block;
    color: #333 !important;
    font-size: 0.9rem;
    &:hover {
      background-color: #EEE;
    }
    &.selected {
      background-color: #2226ca;
      font-weight: 500;
      color: #FFF !important;
    }
  }
}

.planning-action-select {
  max-width: 425px;
  .v-input__prepend-inner {
    padding-right: 8px !important;
    .v-icon {
      font-size: 20px;
    }
  }
  .v-select__slot {
    // padding-right: 28px;
    .v-select__selection {
      max-width: 100% !important;;
    }
  }
  input[type=text] {
    width: 1px !important;
    flex: none;
  }
}

@media only screen and (max-width: 1260px) {
  .planning-action-select {
    max-width: 320px;
  }
}

.planning {
  .search-input {
    .v-input__prepend-inner {
      margin-top: 4px !important;
    }
    .v-input__slot {
      min-height: 32px !important;
    }
  }
}

</style>
